export default function patrimonymaterials(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                patrimonymaterial: action.patrimonymaterial,
            }
        default:
            return state;
    }
}
